import React from "react";
import styled, { keyframes } from "styled-components";
import type { SpinnerProps } from "@xsolla/xui-primitives-core";
import { createFilteredElement } from "./filterDOMProps";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const FilteredDiv = createFilteredElement("div");

const StyledSpinner = styled(FilteredDiv)<SpinnerProps>`
  width: ${(props) =>
    typeof props.size === "number" ? `${props.size}px` : props.size || "24px"};
  height: ${(props) =>
    typeof props.size === "number" ? `${props.size}px` : props.size || "24px"};
  border: ${(props) => props.strokeWidth || 2}px solid
    ${(props) => props.color || "currentColor"};
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: ${rotate} 1s linear infinite;
`;

export const Spinner: React.FC<SpinnerProps> = ({
  role = "status",
  "aria-label": ariaLabel,
  "aria-live": ariaLive = "polite",
  "aria-describedby": ariaDescribedBy,
  testID,
  ...props
}) => {
  return (
    <StyledSpinner
      role={role}
      aria-label={ariaLabel}
      aria-live={ariaLive}
      aria-describedby={ariaDescribedBy}
      data-testid={testID}
      {...props}
    />
  );
};

Spinner.displayName = "Spinner";
